/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_LeadsInputs */

const cs_dashboard_kpi_leads = /** @type {(inputs: Dashboard_Kpi_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nové leady`)
};

const en_dashboard_kpi_leads = /** @type {(inputs: Dashboard_Kpi_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New leads`)
};

/**
* | output |
* | --- |
* | "New leads" |
*
* @param {Dashboard_Kpi_LeadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_leads = /** @type {((inputs?: Dashboard_Kpi_LeadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_LeadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_leads(inputs)
	return cs_dashboard_kpi_leads(inputs)
});